import { PAGES } from '../../router/routes'

export function ValidacaoEstruturaCicloIO() {
  return { voltarPage: PAGES.validacaoEstruturaCiclo, pageValidarExecucao: (parceiroId: number) => PAGES.validacaoEstruturaCicloParceiro(parceiroId) }
}

export type ValidacaoEstruturaCicloIO = ReturnType<typeof ValidacaoEstruturaCicloIO>
